// create slices
import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../../services/api-status.enum";

const initialState = {
  loginDetail: {
    data: {},
    status: ApiStatus.NONE,
    error: null
  }
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    getLoginDetail: (state) => {
      state.loginDetail.status = ApiStatus.LOADING;
    },
    getLoginDetailSuccess: (state, action) => {
      state.loginDetail.status = ApiStatus.SUCCESS;
      state.loginDetail.data = action.payload;
    },
    getLoginDetailFailure: (state, action) => {
      state.loginDetail.status = ApiStatus.ERROR;
      state.loginDetail.error = action.payload;
    },
  },
});

export const { getLoginDetail, getLoginDetailSuccess, getLoginDetailFailure } =
  loginSlice.actions;
export default loginSlice.reducer;
